var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-return-table" },
    [
      _c(
        "el-form",
        {
          staticClass: "search-form",
          attrs: { inline: true, model: _vm.searchForm },
        },
        [
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: { placeholder: "请输入订单号或手机号", clearable: "" },
                model: {
                  value: _vm.searchForm.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "keyword", $$v)
                  },
                  expression: "searchForm.keyword",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetimerange",
                  "range-separator": "~",
                  "start-placeholder": "申请开始时间",
                  "end-placeholder": "申请结束时间",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                model: {
                  value: _vm.searchForm.applyTimeRange,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "applyTimeRange", $$v)
                  },
                  expression: "searchForm.applyTimeRange",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部退货订单", name: "all" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "未受理", name: "pending" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "同意退款", name: "approved" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "拒绝退款", name: "rejected" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已完成", name: "completed" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "returnId", label: "退款单号", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.returnId) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "orderId", label: "订单号", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.orderId) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "买家信息", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.userId
                      ? _c("div", [
                          _vm._v("用户ID: " + _vm._s(scope.row.userId)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.mobile
                      ? _c("div", [_vm._v("手机: " + _vm._s(scope.row.mobile))])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.userpic
                      ? _c(
                          "div",
                          { staticStyle: { "margin-top": "5px" } },
                          [
                            _c("el-avatar", {
                              attrs: { src: scope.row.userpic, size: 40 },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "storeName", label: "门店", width: "200" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "orderAmount", label: "订单金额", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        ¥" +
                        _vm._s(
                          scope.row.orderAmount
                            ? parseFloat(scope.row.orderAmount).toFixed(2)
                            : "0.00"
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "returnMoney", label: "退款金额", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f56c6c",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _vm._v(
                          "\n          ¥" +
                            _vm._s(
                              scope.row.returnMoney
                                ? parseFloat(scope.row.returnMoney).toFixed(2)
                                : "0.00"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "goodsList",
              label: "退单商品",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.goodsList && scope.row.goodsList.length > 0
                      ? _c(
                          "div",
                          _vm._l(scope.row.goodsList, function (item, idx) {
                            return _c("div", { key: item.goodsId || idx }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(idx + 1) +
                                  "." +
                                  _vm._s(item.goodsName) +
                                  " x" +
                                  _vm._s(item.num) +
                                  "\n          "
                              ),
                            ])
                          }),
                          0
                        )
                      : _c("div", [_vm._v("--")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "returnReason",
              label: "退款原因",
              width: "150",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.returnReason || "--") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "addTime", label: "申请时间", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDate(scope.row.addTime)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "returnStatusText",
              label: "退款状态",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getReturnStatusTagType(
                            scope.row.returnStatus
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.returnStatusText) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "returnTypeText", label: "退款类型", width: "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pagination.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pagination.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pagination.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }